import { createAction } from 'reduxStore/actionCreator';
import {
  INIT_STRIPE_REQUEST,
  INIT_STRIPE_REQUEST_SUCCESS,
  CLEAR_STRIPE,
} from 'reduxStore/actionsConst';

export const requestInitStripe = (payload: { supplierId: number; closingBalance: number }) =>
  createAction(INIT_STRIPE_REQUEST, payload);

export type RequestInitStripeAction = ReturnType<typeof requestInitStripe>;

export const resetStripe = () => createAction(CLEAR_STRIPE);

export type ResetStripeAction = ReturnType<typeof resetStripe>;

export const requestInitStripeSuccess = (payload: { stripePublicApiKey: string }) =>
  createAction(INIT_STRIPE_REQUEST_SUCCESS, payload);

export type RequestInitStripeSuccessAction = ReturnType<typeof requestInitStripeSuccess>;
